import { PlusIcon } from "@heroicons/react/24/outline";
import { MAX_EVENT_CHUNKS } from "../constants";
import EventChunkEditor from "./EventChunkEditor";

export default function EventChunksSection({
  eventChunks,
  onChange,
  onAdd,
  onRemove,
}) {
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h2 className="text-lg font-semibold text-gray-900">Event chunks</h2>
        <button
          type="button"
          className="inline-flex items-center gap-2 rounded-xl bg-cyan-500 px-4 py-2 text-sm font-semibold text-white hover:bg-cyan-600 disabled:cursor-not-allowed disabled:bg-cyan-300"
          onClick={onAdd}
          disabled={eventChunks.length >= MAX_EVENT_CHUNKS}
        >
          <PlusIcon className="h-4 w-4" />
          Add event chunk
        </button>
      </div>
      {eventChunks.map((chunk, index) => (
        <EventChunkEditor
          key={chunk.id}
          chunk={chunk}
          index={index}
          canRemove={eventChunks.length > 1}
          onChange={onChange}
          onRemove={onRemove}
        />
      ))}
    </div>
  );
}
